// extracted by mini-css-extract-plugin
export default {"container":"AddInterest_container__Jl7TL","heading":"AddInterest_heading__fmjhm","form":"AddInterest_form__VFVTb","buttonContainer":"AddInterest_buttonContainer__1+CQx"};